import { TextProps } from './TextProps';

export class ProductProps {
  constructor(props = {}) {
    this.commercialNameTextProps = new TextProps(props.commercialNameTextProps || {});
    this.commercialDescriptionTextProps = new TextProps(
      props.commercialDescriptionTextProps || {}
    );
    this.longCommercialDescriptionTextProps = new TextProps(
      props.longCommercialDescriptionTextProps || {}
    );
    this.specialDescriptionTextProps = new TextProps(
      props.specialDescriptionTextProps || {}
    );
    this.pricesTextProps = new TextProps(
      props.pricesTextProps || {}
    );
    this.specialProductsProps = new TextProps(
      props.specialProductsProps || {}
    );
    this.popupCommercialNameTextProps = new TextProps(props.popupCommercialNameTextProps || {});
    this.popupLongCommercialDescriptionTextProps = new TextProps(props.popupLongCommercialDescriptionTextProps || {});
  }
}
